import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./index.css";
store.dispatch("initApp");

// import { library } from "@fortawesome/fontawesome-svg-core";
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Import and register ApexCharts
import VueApexCharts from "vue3-apexcharts";
// import { faEnvelope } from '@fortawesome/free-regular-svg-icons';

// import { library } from '@fortawesome/fontawesome-svg-core'

// library.add(faEnvelope);

import { initMsal } from "@/auth";

// Skool Suite
// Alliance
document.title = process.env.VUE_APP_TITLE || "Alliance";

import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faUser,
    faUsers,
    faBook,
    faClock,
    faMap,
    faVideo,
    faBars,
    faCheckCircle,
    faTimesCircle,
    faPlus,
    faMinus,
    faGraduationCap,
    faTrashAlt,
    faAngleDown,
    faAngleRight,
    faSearch,
    faCommentDots,
    faCheckSquare,
    faThumbsUp,
    faReply,
    faDownload,
    faTimes,
    faEnvelope,
    faSignOutAlt
} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


library.add(faUser, faBook, faUsers, faClock, faMap, faVideo, faBars, faCheckCircle, faTimesCircle, faPlus, faMinus, faGraduationCap, faTrashAlt, faAngleDown, faAngleRight, faSearch, faCommentDots, faCheckSquare, faThumbsUp, faReply, faDownload, faTimes, faSignOutAlt);

const app = createApp(App);



// createApp(App).use(store).use(router).mount('#app')

app.component("font-awesome-icon", FontAwesomeIcon);

app.config.globalProperties.$initMsal = initMsal; 

app.use(store).use(router).use(VueApexCharts).mount("#app");


const ro = new ResizeObserver(() => {});
ro.observe(document.body);
